import { h } from "vue";
import { usePdf } from "@ceereals/vue-pdf";
import ItineraryDocument from "./ItineraryDocument.vue";
async function convertImageToBase64(imageUrl) {
    if (!imageUrl)
        return "";
    try {
        const response = await fetch(imageUrl);
        if (!response.ok)
            return "";
        const blob = await response.blob();
        return await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(typeof reader.result === "string" ? reader.result : "");
            reader.onerror = () => resolve("");
            reader.readAsDataURL(blob);
        });
    }
    catch (error) {
        console.error("Error converting image to base64:", error);
        return "";
    }
}
async function preprocessProjectionImages(projection) {
    const slots = await Promise.all(projection.itinerary.slots_itineraries.map(async (item) => {
        const photos = await Promise.all((item.service?.photos ?? []).map(async (photo) => {
            const base64 = await convertImageToBase64(photo.image_url);
            return { ...photo, image_url: base64 || photo.image_url };
        }));
        return {
            ...item,
            service: item.service
                ? {
                    ...item.service,
                    photos,
                }
                : item.service,
        };
    }));
    const conciergeLogo = await convertImageToBase64(projection.concierge?.image_url);
    const brandLogo = await convertImageToBase64(projection.brand?.logoUrl);
    return {
        ...projection,
        itinerary: {
            ...projection.itinerary,
            slots_itineraries: slots,
            itinerary_tour: slots,
        },
        concierge: projection.concierge
            ? {
                ...projection.concierge,
                image_url: conciergeLogo || projection.concierge.image_url,
            }
            : projection.concierge,
        brand: projection.brand
            ? {
                ...projection.brand,
                logoUrl: brandLogo || projection.brand.logoUrl,
            }
            : projection.brand,
    };
}
export async function generateItineraryPdfBlob(projection) {
    const processedProjection = await preprocessProjectionImages(projection);
    const pdfState = usePdf(h(ItineraryDocument, {
        projection: processedProjection,
    }), {
        reactive: false,
        enableProvideBridge: false,
    });
    try {
        await pdfState.execute(true);
        if (!pdfState.blob.value) {
            throw new Error("No se pudo generar el PDF del itinerario.");
        }
        return pdfState.blob.value;
    }
    finally {
        pdfState.unmount();
    }
}
export async function generateItineraryPdfBytes(projection) {
    const blob = await generateItineraryPdfBlob(projection);
    const arrayBuffer = await blob.arrayBuffer();
    return new Uint8Array(arrayBuffer);
}
export function createPdfFileName(projection) {
    const customer = projection.itinerary.customer;
    const clientName = customer?.name && customer?.last_name
        ? `${customer.name}_${customer.last_name}`
        : customer?.name || "Cliente";
    const cleanName = clientName.replace(/[^a-zA-Z0-9_]/g, "_");
    const date = new Date().toISOString().split("T")[0];
    return `Itinerario_${cleanName}_${date}.pdf`;
}
export function triggerPdfDownload(blob, fileName) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
export async function downloadItineraryPdf(projection) {
    const blob = await generateItineraryPdfBlob(projection);
    triggerPdfDownload(blob, createPdfFileName(projection));
}
export default {
    generateItineraryPdfBlob,
    generateItineraryPdfBytes,
    createPdfFileName,
    triggerPdfDownload,
    downloadItineraryPdf,
};
